// extracted by mini-css-extract-plugin
export default {"loadingContainer":"PropertyNoticeToQuitGuardianLetters_loadingContainer__Uw5F2"};